document.querySelectorAll('.nav-toggle').forEach((toggle) => {
  toggle.setAttribute('aria-label', 'Open navigation');

  toggle.addEventListener('click', () => {
    const nav = toggle.closest('.nav');
    const links = nav?.querySelector('.nav-links');
    if (!links) return;

    const isOpen = links.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
});

document.querySelectorAll('.nav-links').forEach((nav) => {
  nav.setAttribute('aria-label', 'Page navigation');

  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => nav.classList.remove('open'));
  });
});

document.querySelectorAll('[data-carousel]').forEach((carousel) => {
  const slides = [...carousel.querySelectorAll('.carousel-slide')];
  const dots = carousel.querySelector('.carousel-dots');
  const previousButton = carousel.querySelector('.prev');
  const nextButton = carousel.querySelector('.next');

  if (!slides.length || !dots) return;

  let active = 0;
  let timer;
  let touchStart = 0;

  const show = (index) => {
    active = (index + slides.length) % slides.length;

    slides.forEach((slide, position) => {
      const isActive = position === active;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    [...dots.children].forEach((dot, position) => {
      const isActive = position === active;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', String(isActive));
    });
  };

  const stop = () => window.clearInterval(timer);

  const restart = () => {
    stop();
    if (slides.length > 1 && !document.hidden) {
      timer = window.setInterval(() => show(active + 1), 4500);
    }
  };

  dots.replaceChildren();

  slides.forEach((_, position) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'carousel-dot';
    dot.setAttribute('aria-label', `View store photo ${position + 1}`);
    dot.addEventListener('click', () => {
      show(position);
      restart();
    });
    dots.appendChild(dot);
  });

  previousButton?.setAttribute('aria-label', 'Previous store photo');
  nextButton?.setAttribute('aria-label', 'Next store photo');
  previousButton?.addEventListener('click', () => {
    show(active - 1);
    restart();
  });
  nextButton?.addEventListener('click', () => {
    show(active + 1);
    restart();
  });

  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', restart);
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', restart);
  carousel.addEventListener('touchstart', (event) => {
    touchStart = event.changedTouches[0].clientX;
  }, { passive: true });
  carousel.addEventListener('touchend', (event) => {
    const delta = event.changedTouches[0].clientX - touchStart;
    if (Math.abs(delta) <= 45) return;

    show(active + (delta < 0 ? 1 : -1));
    restart();
  }, { passive: true });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else restart();
  });

  show(0);
  restart();
});
